import React from 'react';
import Button from 'react-bootstrap/Button';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const QuoteAction = (props) => {
  const {
    onClick,
    label,
    icon,
    disabled,
  } = props;

  return (
    <Button
      variant="outline-dark"
      className="quote-action"
      disabled={disabled}
      onClick={onClick}>
      <FontAwesomeIcon icon={icon} className="mr-2" />
      {label}
    </Button>
  );
};

QuoteAction.defaultProps = {
  onClick: null,
  label: '',
  icon: null,
  disabled: false,
};

QuoteAction.propTypes = {
  onClick: PropTypes.func,
  label: PropTypes.string,
  icon: PropTypes.object,
  disabled: PropTypes.bool,
};

export default QuoteAction;
